import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-otp-validation-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './otp-validation-dialog.component.html',
  styleUrls: ['./otp-validation-dialog.component.css']
})
export class OtpValidationDialogComponent implements OnInit {
  @Input() isVisible: boolean = false;
  @Input() title!: string;
  @Input() description!: string;
  
  @Output() isVisibleChange = new EventEmitter<boolean>();
  @Output() closed = new EventEmitter<void>();
  @Output() submit = new EventEmitter<string>();

  otp: string = '';
  otpError: string = '';
  isSubmitting: boolean = false;

  ngOnInit(): void {
    this.resetForm();
  }

  close(): void {
    this.isVisible = false;
    this.isVisibleChange.emit(false);
    this.closed.emit();
    this.resetForm();
  }

  handleBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }

  handleSubmit(): void {
    if (!this.isFormValid() || this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    this.otpError = '';

    // Validate OTP format (6 digits)
    if (!/^\d{6}$/.test(this.otp)) {
      this.otpError = 'OTP must be 6 digits';
      this.isSubmitting = false;
      return;
    }

    this.submit.emit(this.otp);
    this.isSubmitting = false;
  }

  handleCancel(): void {
    this.close();
  }

  onOtpInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    // Only allow digits and limit to 6 characters
    this.otp = input.value.replace(/\D/g, '').slice(0, 6);
    this.otpError = '';
  }

  isFormValid(): boolean {
    return this.otp.length === 6;
  }

  private resetForm(): void {
    this.otp = '';
    this.otpError = '';
    this.isSubmitting = false;
  }
}
